import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const DynamicBreadcrumb = ({ pageData }) => {
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    
    if (pageData.sp_id === 0)
    {
        switch (pageData.sp_name) 
        {
            case "EventDetails":
                pageData = {
                    ...pageData,
                    sp_name: 'Event Details',
                    sp_name_hi: 'घटनाक्रम विवरण',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;                    
            case "NoticeDetails":
                pageData = {
                    ...pageData,
                    sp_name: 'Notice Details',
                    sp_name_hi: 'नोटिस विवरण',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;
            case "AchievementDetails":
                pageData = {
                    ...pageData,
                    sp_name: 'Achievement Details',
                    sp_name_hi: 'उपलब्धि विवरण',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;
            case "ExamDetails":
                pageData = {
                    ...pageData,
                    sp_name: 'Exam Details',
                    sp_name_hi: 'परीक्षा विवरण',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;                    
            case "FacultyDetails":
                pageData = {
                    ...pageData,
                    sp_name: 'Profile Details',
                    sp_name_hi: 'प्रोफ़ाइल विवरण',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;
            case "FacultyPublications":
                pageData = {
                    ...pageData,
                    sp_name: 'Profile Publications',
                    sp_name_hi: 'प्रोफ़ाइल प्रकाशन',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;
            case "ClubsSocietiesDetails":
                pageData = {
                    ...pageData,
                    sp_name: 'Clubs-Societies Details',
                    sp_name_hi: 'क्लब-सोसायटी विवरण',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;
            case "GlimpsesDetails":
                pageData = {
                    ...pageData,
                    sp_name: 'Glimpses Details',
                    sp_name_hi: 'झलकियाँ विवरण',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;
            case "ProgramDetails":
                pageData = {
                    ...pageData,
                    sp_name: 'Program Details',
                    sp_name_hi: 'प्रोग्राम विवरण',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;
            default:
                pageData = {
                    ...pageData,
                    sp_name: '404 Page',
                    sp_name_hi: '404 पेज',
                    sp_htaccess: '',
                    parentPage:null,
                };
                break;
        }
    }
    const generateBreadcrumbTrail = (page) => {
        const trail = [];
        let current = page;

        while (current) {
            trail.unshift({
                name: appLanguage === 'hi' ? current.sp_name_hi : current.sp_name,
                link: appLanguage === 'hi' ? current.sp_htaccess_hi : current.sp_htaccess, // Link to the page if available
            });
            current = current.parentPage;
        }

        // Accumulate the links
        trail.reduce((acc, item, index) => {
            item.link = acc + (acc.endsWith('/') ? '' : '/') + item.link; // Append current link to previous
            return item.link; // Carry forward the accumulated link
        }, '');

        return trail;
    };
    //console.log(pageData);
    const breadcrumbTrail = generateBreadcrumbTrail(pageData);
    return (
        <Breadcrumb>
            <li className="breadcrumb-item">
                <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>
                    {appLanguage === 'hi' ? 'होम' : 'Home'}
                </NavLink>
            </li>
            {breadcrumbTrail.map((item, index) => (
                <li
                    key={index}
                    className={`breadcrumb-item ${index === breadcrumbTrail.length - 1 ? 'active' : ''}`}
                >
                    {index === breadcrumbTrail.length - 1 ? (
                        item.name
                    ) : (
                        <NavLink to={item.link} className={({ isActive }) => (isActive ? 'active' : '')}>
                            {item.name}
                        </NavLink>
                    )}
                </li>
            ))}
        </Breadcrumb>
    );
};

export default DynamicBreadcrumb;
